import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators, FormArrayName } from '@angular/forms';
import { AddallowancepopupComponent } from '../../generalpopup/addallowancepopup/addallowancepopup.component';
import { AdddeductionpopupComponent } from '../../generalpopup/adddeductionpopup/adddeductionpopup.component';
@Component({
  selector: 'app-shorttermpaydetails',
  templateUrl: './shorttermpaydetails.component.html',
  styleUrls: ['./shorttermpaydetails.component.css']
})
export class ShorttermpaydetailsComponent implements OnInit {


  constructor(private toastr: ToastrService, private appService: AppdataService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService,
    private productFindService: NgbModal) { }

  //Save Validation
  submitted: boolean;
  successfully: boolean;

  isduplicate: boolean;

  isallowanceaddmode: boolean;
  isdeductionaddmode: boolean;

  shorttermpaydetailform = new FormGroup({
    shorttermpaydetid: new FormControl(0),
    allowanceid: new FormControl(null),
    amount: new FormControl(0,Validators.required),
    deductionid: new FormControl(null),

  });

  allowanceColl: any = [];
  deductionColl: any = [];

  @Input() shorttermpaydetid: any = 0;
  @Input() allowanceid: any = null;
  @Input() amount: any = null;
  @Input() deductionid: any = 0;
  @Input() formname: String = null;
  @Input() shorttermpaydetailColl: any = [];

  @Input() adjustmenttype: String = null;

  @Output() emitData = new EventEmitter();

  ngOnInit() {

    this.shorttermpaydetailform.reset();
    this.fnInitializeFormGroup();
    this.fngetAllowance();
    this.fngetDeduction();

  }
  fnCheckUserPririvilage() {
  
    this.isallowanceaddmode= this.loginService.fnCheckUserRoleAction("Allowance", 'CREATE')
    this.isdeductionaddmode= this.loginService.fnCheckUserRoleAction("Deduction", 'CREATE')

   
  }


  fnInitializeFormGroup() {
    this.shorttermpaydetailform.setValue({
      shorttermpaydetid: this.shorttermpaydetid,
      allowanceid: this.allowanceid,
      amount: this.amount,
      deductionid: this.deductionid,
    })

  }
  fngetAllowance() {
    var data = {
      'allowanceid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': ""
    }
    this.appService.getAllowance(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.allowanceColl = res.json().result;

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetDeduction() {
    var data = {
      'deductionid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': ""
    }
    this.appService.getDeduction(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.deductionColl = res.json().result;

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate

      if (this.shorttermpaydetailform.valid) {

        var _allowancename = "";
        var _deductionname = "";
        for (let row of this.allowanceColl) {
          if (row.allowanceid === this.shorttermpaydetailform.get('allowanceid').value) {
            _allowancename = row.allowancename;
          }

        }
        for (let row of this.shorttermpaydetailColl) {
          if (row.allowanceid === this.shorttermpaydetailform.get('allowanceid').value && this.allowanceid !== this.shorttermpaydetailform.get('allowanceid').value) {
            this.isduplicate = true;
            return;
          }
        }

        for (let row of this.deductionColl) {
          if (row.deductionid === this.shorttermpaydetailform.get('deductionid').value) {
            _deductionname = row.deductionname;
            console.log(_deductionname);
          }

        }
        for (let row of this.shorttermpaydetailColl) {
          if (row.deductionid === this.shorttermpaydetailform.get('deductionid').value && this.deductionid !== this.shorttermpaydetailform.get('deductionid').value) {
            this.isduplicate = true;
            return;
          }
        }

        //Check
        var data = {
          shorttermpaydetid: this.shorttermpaydetid,
          allowanceid: this.shorttermpaydetailform.get('allowanceid').value,
          deductionid: this.shorttermpaydetailform.get('deductionid').value,
          amount: this.shorttermpaydetailform.get('amount').value,
          allowancename: _allowancename,
          deductionname: _deductionname,
        }



        this.emitData.emit(data);
        this.activeModal.close(true);


      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }

  }

//AddAllowance
private fnAddAllowance() {

  const modalRef = this.productFindService.open(AddallowancepopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetAllowance();

    if (receivedEntry > 0) {
      this.shorttermpaydetailform.patchValue({ allowanceid: receivedEntry })
    }
  });

}
//AddAllowance
private fnAddDeduction() {

  const modalRef = this.productFindService.open(AdddeductionpopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetDeduction();

    if (receivedEntry > 0) {
      this.shorttermpaydetailform.patchValue({ deductionid: receivedEntry })
    }
  });

  }
  
  public fnSetValidator() {
    if (this.formname === 'ALLOWANCE') {
      this.shorttermpaydetailform.controls['allowanceid'].setValidators(Validators.required); 
    } else {
      this.shorttermpaydetailform.controls['allowanceid'].clearValidators();
      this.shorttermpaydetailform.controls['allowanceid'].setErrors(null);
      this.shorttermpaydetailform.controls['allowanceid'].setValidators(null);
    }

    if (this.formname === 'DEDUCTION') {
      this.shorttermpaydetailform.controls['deductionid'].setValidators(Validators.required); 
    } else {
      this.shorttermpaydetailform.controls['deductionid'].clearValidators();
      this.shorttermpaydetailform.controls['deductionid'].setErrors(null);
      this.shorttermpaydetailform.controls['deductionid'].setValidators(null);
    }

  }

  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
